module.exports = __webpack_public_path__ + "img/logo.15b9c9c2.png";